/* @flow */

import {withStyles} from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

const StyledTableCellNumbersOrangeComponent = withStyles(_ => ({
  root: {
    padding: '4px 56px 4px 24px'
  },
  head: {
    lineHeight: '1.5'
  },
  // paddingSpace: {
  //   padding: 0,
  //   width: 'auto'
  // },
  paddingNone: {
    padding: '0 12px',
    width: 'auto'
  },
  body: {
    fontSize: '0.8125rem',
    textAlign: 'right',
    color: 'orange'
  },

}))(TableCell);

export default StyledTableCellNumbersOrangeComponent;
